import { Components, Theme } from "@mui/material/styles";

export const MuiTab = () =>
  ({
    MuiTab: {
      styleOverrides: {
        root: {
          maxWidth: "none",
        },
      },
    },
  }) satisfies Components<Theme>;
